
import { useNavigate } from "react-router-dom";

export default function Unauthorised() {

    const navigate = useNavigate();

    // const navigate = useNavigate()

    const redirect = () => {
        navigate(-2)

    }


    return (
        <div className="d-flex vh-100 bg-primary text-white justify-content-center align-items-center flex-column">
        <h1 className="display-1 fw-bold">Oops! Page not found.</h1>
        {/* <p className="fs-3">Oops! Page not found.</p> */}
        <p className="lead">You have not been authorized to view this page.</p>
        <button onClick={redirect} className="btn btn-light mt-3">Go Back</button>
      </div>
    );
}